import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const checkConsent = () => {
      const consent = localStorage.getItem('cookie_consent');
      if (consent) return;
      
      // Wait for announcement popup to be dismissed first
      const announcementEl = document.querySelector('[data-testid="announcement-popup"]');
      if (announcementEl) {
        // Announcement is showing — check again later
        setTimeout(checkConsent, 500);
        return;
      }
      setVisible(true);
    };

    // Small delay to let announcement popup render first
    setTimeout(checkConsent, 800);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    window.dispatchEvent(new Event('cookie-consent-granted'));
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    if (window.gtag) {
      window.gtag('consent', 'update', { 'analytics_storage': 'denied' });
    }
    document.cookie.split(';').forEach(c => {
      const name = c.trim().split('=')[0];
      if (name.startsWith('_ga') || name.startsWith('_gid')) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.' + window.location.hostname;
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
      }
    });
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] p-3 md:p-6" data-testid="cookie-consent-banner">
      <div className="max-w-4xl mx-auto bg-[#141417] border border-zinc-700 rounded-xl p-3 md:p-6 shadow-2xl">
        <p className="text-zinc-400 text-xs md:text-sm leading-relaxed mb-3">
          {t('cookies.message')}{' '}
          <Link to="/privacy" className="text-[#FFC107] hover:underline">{t('cookies.learnMore')}</Link>
        </p>
        <div className="flex gap-2">
          <button
            onClick={handleDecline}
            className="flex-1 px-3 py-2 rounded-lg border border-zinc-600 text-zinc-300 text-xs md:text-sm font-medium hover:bg-[#25252E] transition-colors"
            data-testid="cookie-decline-btn"
          >
            {t('cookies.decline')}
          </button>
          <button
            onClick={handleAccept}
            className="flex-1 px-3 py-2 rounded-lg bg-[#FFC107] text-black text-xs md:text-sm font-bold hover:bg-[#FFD54F] transition-colors"
            data-testid="cookie-accept-btn"
          >
            {t('cookies.accept')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
